import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "antd/dist/reset.css";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import ListedPropertiesPage from "./pages/ListedPropertiesPage";
import ListPropertyPage from "./pages/ListPropertyPage";
import ListingPoliciesPage from "./pages/ListingPoliciesPage";
import ListPropertyFormPage from "./pages/ListPropertyFormPage";
import ListingConfirmationPage from "./pages/ListingConfirmationPage";
import HowWeWorkPage from "./pages/HowWeWorkPage";
import OurStory from "./pages/OurStory";
import PropertyDetail from "./pages/PropertyDetail";
import Chatbot from "./components/Chatbot";
import NewsroomPage from "./pages/NewsRoomPage";
import ContactUs from "./pages/ContactUs";
import TermOfUse from "./pages/TermOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TeamPage from "./pages/TeamPage";
import EmergencyPropertyPage from "../src/pages/EmergencyPropertyPage";

const routes = [
  { path: "/", element: <HomePage /> },
  { path: "/about-us", element: <AboutUsPage /> },
  { path: "/listed-property", element: <ListedPropertiesPage /> },
  { path: "/list", element: <ListPropertyPage /> },
  { path: "/policy", element: <ListingPoliciesPage /> },
  { path: "/form", element: <ListPropertyFormPage /> },
  { path: "/confirmation", element: <ListingConfirmationPage /> },
  { path: "/work", element: <HowWeWorkPage /> },
  { path: "/our-story", element: <OurStory /> },
  { path: "/property-detail/:id", element: <PropertyDetail /> },
  { path: "/news-room", element: <NewsroomPage /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/terms", element: <TermOfUse /> },
  { path: "/privacy", element: <PrivacyPolicy /> },
  { path: "/cookie-policy", element: <CookiePolicy /> },
  { path: "/team", element: <TeamPage /> },
  { path: "/emergency-property", element: <EmergencyPropertyPage/> },
];

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>

      {/*Floating Chatbot appears on every page */}
      <Chatbot />
    </BrowserRouter>
  );
}

export default App;
